import { api } from 'services/api';

const paymentService = api
  .enhanceEndpoints({
    addTagTypes: ['StoredCards'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      binInquiry: builder.mutation<ResultModel<BinInquiryResponse>, BinInquiryRequest>({
        query: (body) => ({
          url: `/44337BBC3AD660/BinInquiry`,
          method: 'POST',
          body,
        }),
        extraOptions: { isProfile: true },
      }),
      patientPaymentCreating: builder.mutation<
        ResultModel<PatientPaymentCreatingResponse>,
        PatientPaymentCreatingRequest
      >({
        query: (body) => ({
          url: `/44337BBC3AD660/PatientPaymentCreating`,
          method: 'POST',
          body,
        }),
        extraOptions: { isProfile: true },
      }),
      storedCards: builder.query<ResultModel<StoredCardsResponse>, StoredCardsRequest>({
        query: (body) => ({
          url: `/44337BBC3AD660/stored-cards.json`,
          method: 'POST',
          body,
        }),
        providesTags: [{ type: 'StoredCards', id: 'LIST' }],
        extraOptions: { isProfile: true },
      }),
      deleteStoredCard: builder.mutation<ResultModel<void>, DeleteStoredCardRequest>({
        query: (body) => ({
          url: `/44337BBC3AD660/delete-stored-card.json`,
          method: 'POST',
          body,
        }),
        invalidatesTags: [{ type: 'StoredCards', id: 'LIST' }],
        extraOptions: { isProfile: true },
      }),
      storedCardSetDefault: builder.mutation<ResultModel<void>, StoredCardSetDefaultRequest>({
        query: (body) => ({
          url: `/44337BBC3AD660/stored-card-set-default.json`,
          method: 'POST',
          body,
        }),
        invalidatesTags: [{ type: 'StoredCards', id: 'LIST' }],
        extraOptions: { isProfile: true },
      }),
      storeCard: builder.mutation<ResultModel<StoreCardResponse>, StoreCardRequest>({
        query: (body) => ({
          url: `/44337BBC3AD660/store-card.json`,
          method: 'POST',
          body,
        }),
        invalidatesTags: [{ type: 'StoredCards', id: 'LIST' }],
        extraOptions: { isProfile: true },
      }),
      freePayment: builder.mutation<ResultModel<void>, FreePaymentRequest>({
        query: (body) => ({
          url: `/44337BBC3AD660/FreePayment`,
          method: 'POST',
          body,
        }),
        extraOptions: { isProfile: true },
      }),
    }),
  });

export const {
  useBinInquiryMutation,
  usePatientPaymentCreatingMutation,
  useStoredCardsQuery,
  useDeleteStoredCardMutation,
  useStoredCardSetDefaultMutation,
  useStoreCardMutation,
  useFreePaymentMutation,
} = paymentService;

